import $ from 'jquery'

$(document).on('click', '.attachment-embed-toggle', function (e) {
  e.preventDefault()
  const container = $(e.target).closest('.course-lesson__attachment__container')
  container.toggleClass('embed-shown')
})
